import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetCulturesQueryResponse, GetCultures400, GetCultures404, GetCultures500 } from "../types/GetCultures";

export const getCulturesQueryKey = () =>     [{url:`/api/requests/cultures`}] as const;
      export function getCulturesQueryOptions <TData = GetCulturesQueryResponse, TError = GetCultures400 | GetCultures404 | GetCultures500>(options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getCulturesQueryKey();

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/requests/cultures`,
              
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @summary Получение культур
 * @link /api/requests/cultures
 */

export function useGetCultures <TData = GetCulturesQueryResponse, TError = GetCultures400 | GetCultures404 | GetCultures500>(options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getCulturesQueryKey();

  const query = useQuery<TData, TError>({
    ...getCulturesQueryOptions<TData, TError>(clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
